<div class="session-expired">
    <p>{{ 'CfnEcmFront_SessionExpired_Message' | translate }}</p>
    <div class="actions">
        <button mat-flat-button color="accent" (click)="onReconnect()">{{ 'CfnEcmFront_SessionExpired_Reconnect' | translate }}</button>
    </div>
</div>
